module.exports = __webpack_public_path__ + "static/media/GSTFormat.2e733cbd.svg";